import { render } from "./MyEducations.vue?vue&type=template&id=40332a9f&scoped=true"
import script from "./MyEducations.vue?vue&type=script&lang=js"
export * from "./MyEducations.vue?vue&type=script&lang=js"

import "./MyEducations.vue?vue&type=style&index=0&id=40332a9f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40332a9f"]])

export default __exports__